import { cva, type VariantProps } from 'class-variance-authority'

const dottedCircleVariants = cva(
  'w-6 h-6 rounded-full border-2 border-dashed',
  {
    variants: {
      state: {
        default: 'border-gray-400',
        active: 'border-orange-500',
        completed: 'border-green-500',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
)

interface Props extends VariantProps<typeof dottedCircleVariants> {}

function DottedCircle({ state }: Props) {
  return <div className={dottedCircleVariants({ state })} />
}

export default DottedCircle
